"use client";

import { Award, Clock, ShieldCheck, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseItems = [{
  icon: Zap,
  title: "Eficiencia de Costos",
  description: "Sin precios por usuario, solo una licencia anual fija para reducir drásticamente sus gastos operativos."
}, {
  icon: ShieldCheck,
  title: "Soberanía de Datos",
  description: "Mantenga su información privada y segura sin cargas a terceros, garantizando control total sobre sus datos."
}, {
  icon: Award,
  title: "Escalabilidad Total",
  description: "Crezca sin límites desde 25 usuarios hasta implementaciones empresariales masivas con total flexibilidad."
}, {
  icon: Clock,
  title: "Confianza Global",
  description: "Más de 350,000 empresas confían en nosotros, incluyendo gigantes como Honda, Pizza Hut y Porsche."
}];
export default function WhyChoose3cx() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257596" id="why-choose-3cx" className="bg-background py-24 border-y border-[#EEEEEE]">
      <div className="page-container">
        <div className="text-center mb-16">
          <span className="text-primary font-semibold tracking-wider uppercase text-sm mb-4 block">
            Ventajas Competitivas
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground font-default">
            ¿Por qué elegir 3CX?
          </h2>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {expertiseItems.map((item, i) => <div key={i} data-index={i} className={`flex flex-col items-center text-center transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <div className="w-16 h-16 rounded-lg border border-border bg-accent flex items-center justify-center mb-6 text-primary shrink-0 shadow-sm">
                <item.icon className="w-8 h-8" strokeWidth={1.5} />
              </div>
              <h3 className="text-[24px] font-bold text-foreground font-default mb-4">
                {item.title}
              </h3>
              <p className="text-[18px] text-muted-foreground font-default leading-relaxed">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}